import { lazy, Suspense } from "react";
import { Toaster } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { Route, Switch } from "wouter";
import ErrorBoundary from "./components/ErrorBoundary";
import { ThemeProvider } from "./contexts/ThemeContext";
import GlobalBrandStyles from "./components/GlobalBrandStyles";

const Home = lazy(() => import("./pages/Home"));
const Login = lazy(() => import("./pages/Login"));
const SharedDashboard = lazy(() => import("./pages/SharedDashboard"));
const PropertyManagement = lazy(() => import("./pages/PropertyManagement"));
const StandaloneProposalReview = lazy(() => import("./pages/StandaloneProposalReview"));
const NotFound = lazy(() => import("./pages/NotFound"));

function PageLoader() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50 dark:bg-slate-950">
      <div className="animate-spin h-8 w-8 border-[3px] border-slate-200 dark:border-slate-800 border-t-blue-600 rounded-full" />
    </div>
  );
}

function Router() {
  return (
    <Suspense fallback={<PageLoader />}>
      <Switch>
        <Route path={"/"} component={Home} />
        <Route path={"/budget/cross-checks"} component={Home} />
        <Route path={"/budget/:subView"} component={Home} />
        <Route path={"/budget"} component={Home} />
        <Route path={"/login"} component={Login} />
        <Route path={"/properties"} component={PropertyManagement} />
        <Route path={"/share/:token"} component={SharedDashboard} />
        <Route path={"/budget/review/:token"} component={StandaloneProposalReview} />
        <Route path={"/404"} component={NotFound} />
        {/* Final fallback route */}
        <Route component={NotFound} />
      </Switch>
    </Suspense>
  );
}

function App() {
  return (
    <ErrorBoundary>
      <ThemeProvider defaultTheme="light">
        <TooltipProvider>
          <Toaster />
          <GlobalBrandStyles />
          <Router />
        </TooltipProvider>
      </ThemeProvider>
    </ErrorBoundary>
  );
}

export default App;
